import styled from 'styled-components';
import { IconButtonVariant, IconButtonSize } from './types';

interface StyledIconButtonProps {
  $variant: IconButtonVariant;
  $size: IconButtonSize;
}

const sizeStyles = {
  sm: `
    padding: 0.375rem;
    svg {
      width: 1rem;
      height: 1rem;
    }
  `,
  md: `
    padding: 0.5rem;
    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  `,
  lg: `
    padding: 0.625rem;
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  `,
};

const variantStyles = {
  default: `
    color: var(--color-text-secondary);
    
    &:hover:not(:disabled) {
      color: var(--color-text-primary);
      background-color: var(--color-gray-100);
    }
    
    &:active:not(:disabled) {
      background-color: var(--color-gray-200);
    }
  `,
  primary: `
    color: var(--color-primary);
    
    &:hover:not(:disabled) {
      background-color: var(--color-primary-light-10);
    }
    
    &:active:not(:disabled) {
      background-color: var(--color-primary-light-20);
    }
  `,
  ghost: `
    color: var(--color-text-secondary);
    
    &:hover:not(:disabled) {
      color: var(--color-text-primary);
    }
    
    &:active:not(:disabled) {
      color: var(--color-primary);
    }
  `,
};

export const StyledIconButton = styled.button<StyledIconButtonProps>`
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  transition: all 0.2s ease;
  user-select: none;
  
  ${({ $size }) => sizeStyles[$size]}
  ${({ $variant }) => variantStyles[$variant]}
  
  &:focus {
    outline: none;
  }
  
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
